<template>
  <div class="upload">
    <el-upload
      ref="upload"
      :show-file-list="false"
      multiple
      drag
      :format="['jpg', 'jpeg', 'png']"
      accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG"
      :action="uploadHost"
      :data="uploadData"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :clearFiles="clearFiles"
      :default-file-list="file_list"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :max-size="size"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        只能上传jpg/png/jpeg文件，且不超过{{ size / 1024 }}M
      </div>
    </el-upload>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from '@/libs/uploadFile'
import { getpublicImgUrl } from '@/api/base/api-upload'

export default {
  props: {
    max: {
      type: Number,
      default: 1
    },
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: ''
    },
    size: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Number | String,
      default: 2048
    }
  },
  data() {
    return {
      showModal: false,
      // 附件上传路径
      uploadHost: '',
      type: 1,
      path: '',
      format: '[]',
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: '',
        oFileName: '',
        fileUrl: '',
        uploadRes: null
      },
      file_list: []
    }
  },
  mounted() {
    this.init(0, 'public/product/')
  },
  methods: {
    // type 0公有 1私有
    init(type, path) {
      this.type = type
      this.path = path
    },
    beforeUpload(file) {
      // if (this.list.length >= this.max) {
      //   this.$message.warning(`最多能上传${this.max}张图片`)
      //   return false
      // }
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host
        this.uploadData = res
        this.fileData.fileName = res.key
        this.fileData.oFileName = file.name
        this.fileData.fileUrl = res.key
      })
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data
            this.fileData.name = this.fileData.fileName
            this.fileData.url = res.data
            this.$emit('input', res.data)
          } else {
            this.$message.success('获取图片链接失败')
          }
        })
      }
    },
    closeHandle() {
      this.showModal = false
    },
    ok() {
      // this.$emit('childByValue', this.file_list)
    },
    clearFiles() {
      this.fileData = {
        fileName: '',
        fileUrl: '',
        uploadRes: null
      }
      this.file_list = []
    },
    handleRemove(file) {
      // 实现缩略图模板时删除文件
      const fileList = this.$refs.upload.uploadFiles
      const index = fileList.findIndex((fileItem) => {
        return fileItem.uid === file.uid
      })
      fileList.splice(index, 1)
    },
    handleFormatError(file) {
      this.$message({
        message: '图片格式错误',
        type: 'warning'
      })
    },
    handleMaxSize(file) {
      const size = parseInt(this.size / 1024)
      this.$message({
        message: `图片${file.name}不能超过${size}M`,
        type: 'warning'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
